// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__9W094","col":"styles_col__1ANWa"};